import { ActionChip, useOverlay } from '@fs/zion-ui'

import React from 'react'
import { useTranslation } from 'react-i18next'
import RestoreTombstonedGroupDialogOverlay from './RestoreTombstonedGroupDialogOverlay'
import RestoreTombstonedPersonDialogOverlay from './RestoreTombstonedPersonDialogOverlay'

export default function RestoreTombstonedEntityChip({ type }) {
  const { t } = useTranslation()
  const restoreConfirmationOverlay = useOverlay()

  return (
    <>
      <span style={{ display: 'inline-block' }}>
        <ActionChip label={t('action.restore', 'Restore')} onClick={restoreConfirmationOverlay.handleClick} selected />
      </span>
      {type === 'personId' && <RestoreTombstonedPersonDialogOverlay {...restoreConfirmationOverlay} />}
      {type === 'groupId' && <RestoreTombstonedGroupDialogOverlay {...restoreConfirmationOverlay} />}
    </>
  )
}
